export const PathDefinition = {
    home: '/',
    account: '/account',
    signIn: '/signIn',
    forgotPassword: '/forgotPassword',
    masterData: '/masterData',
    createMasterData: '/createMasterData/:type',
    importMasterData: '/importMasterData/:type',
    updateMasterData: '/updateMasterData/:type/:code',
    listProduct: '/listProduct',
    importProduct: '/importProduct',
    updateProduct: '/updateProduct/:productId',
    importProductCost: '/importProductCost',
    importEstimatedShippingFee: '/importEstimatedShippingFee',
    listMarketplaceOrder: '/listMarketplaceOrder',
    importMarketplaceOrder: '/importMarketplaceOrder',
    updateMarketplaceOrder: '/updateMarketplaceOrder/:orderId',
    importMarketplaceOrderItem: '/importMarketplaceOrderItem',
    importShippingFee: '/importShippingFee',
    listCurrencyRate: '/listCurrencyRate',
    importCurrencyRate: '/importCurrencyRate',
    calculateGrossProfit: '/calculateGrossProfit',
    listGrossProfit: '/listGrossProfit',
    deleteGrossProfit: '/deleteGrossProfit',
    listRefund: '/listRefund',
    importRefund: '/importRefund',
    listPayment: '/listPayment',
    importPayment: '/importPayment',
    listTransaction: '/listTransaction',
    generateTransaction: '/generateTransaction'
};
